// VAT rate for seafood products in Netherlands
export const VAT_RATE = 0.09; // 9%

/**
 * Calculate VAT amount from a price that includes VAT
 * @param priceInclVat - Price including VAT
 * @returns VAT amount
 */
export const calculateVatAmount = (priceInclVat: number): number => {
  return priceInclVat - (priceInclVat / (1 + VAT_RATE));
};

/**
 * Calculate price excluding VAT from a price that includes VAT
 * @param priceInclVat - Price including VAT
 * @returns Price excluding VAT
 */
export const calculatePriceExclVat = (priceInclVat: number): number => {
  return priceInclVat / (1 + VAT_RATE);
};

/**
 * Get VAT breakdown for a total amount
 * @param totalInclVat - Total amount including VAT
 * @returns Object with price excluding VAT, VAT amount, and total including VAT
 */
export const getVatBreakdown = (totalInclVat: number) => {
  const priceExclVat = calculatePriceExclVat(totalInclVat);
  const vatAmount = calculateVatAmount(totalInclVat);
  
  return {
    priceExclVat,
    vatAmount,
    priceInclVat: totalInclVat,
  };
};
